const easeOutQuint = 'cubic-bezier(0.22, 1, 0.36, 1)';

export const easings = { easeOutQuint };
